<template lang='pug'>
//- 刪除EPRO紀錄區塊
div(:class='$style[`cc-popbox-delete-warning`]')
  div(:class='$style[`cc-content-new`]')
    IconWarn(:size='70')
    span.font-medium(:class='$style[`cc-popbox-delete-info`]') 刪除此ePRO紀錄？
    span.font-medium(:class='$style[`cc-popbox-delete-info-tips`]') 提醒您，刪除後無法復原。

    div(:class='$style[`cc-content-btn-area`]')
      button(
        title='取消'
        tabindex='0' aria-label='取消刪除'
        :class='[$style[`cc-content-btn`], $style[`cc-content-btn-cancel`]]'
        @click='handleClickToCancel')
        span 取消

      button(
        title='刪除'
        tabindex='0' aria-label='刪除此ePRO紀錄'
        :class='[$style[`cc-content-btn`], $style[`cc-content-btn-delete`]]'
        @click='handleClickToDelete')
        span 刪除

</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import IconWarn from '../../icon/Warn';
import GlobalEmitter from 'tiny-emitter/instance';

import {
  deleteSideEffectRecord,
} from '../../../js/restapi';

export default {
  components: {
    IconWarn,
  },

  props: {
    id: {
      type: String,
      default: '',
    },
  },

  // data() {
  //   return {
  //   };
  // },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopDeleteEproStatus: 'global/POPDELETE_EPRO_STATUS',
      changePopEproRecordStatus: 'global/POPEPRO_RECORD_DETAIL',
    }),

    handleClickToCancel() {
      this.changePopDeleteEproStatus({
        active: false,
        id: '',
      });
    },

    handleClickToDelete() {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;
      const UPDATE_DATA = {
        rid: `${this.id}`,
      };

      deleteSideEffectRecord('', {
        headers: {
          'content-Type': 'application/json',
          // Authorization: `Bearer ${jwtAccess}`,
        },
        data: JSON.stringify(UPDATE_DATA),
      })
        .then((/* response */) => {
          console.log('刪除ePRO紀錄 成功!');
          const deleteProcess = new Promise((resolve) => {
            this.changePopEproRecordStatus({
              active: false,
              recordId: null,
            });
            this.handleClickToCancel();
            this.$router.replace({
              path: '/sideeffect/record',
            });

            return resolve();
          });

          deleteProcess.then(() => {
            this.changePopBoxStatus({
              active: true,
              include: 'sendDelete',
            });

            GlobalEmitter.emit('reload-record');
            GlobalEmitter.emit('reload-analysis');

            setTimeout(() => {
              this.changePopBoxStatus({
                active: false,
                include: '',
              });
            }, this.POP_DURATION);
          });
        })
        .catch((error) => {
          console.error('刪除翻譯紀錄 失敗！', error.message);
        });
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      // loginStatus: 'user/exportLoginStatus',
      // loginProfile: 'user/exportUserProfile',
      loginDjangoId: 'user/exportUserDjangoId',
      authJwtToken: 'user/exportUserJwtToken',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popDeleteWarning.scss';
</style>
